"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const React = __importStar(require("react"));
const Theme_1 = require("../../Theme/Theme");
const SpinnerContainer = Theme_1.styled.div `
  align-items: center;
  background: transparent;
  display: flex;
  height: ${(props) => props.size}px;
  justify-content: center;
  width: 100%;
`;
const SpinnerRotator = Theme_1.styled.div `
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  animation: rotate 1.4s linear infinite;
  -webkit-animation: rotate 1.4s linear infinite;
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  } ;
`;
const Progress = Theme_1.styled.circle `
  animation: spin 1.4s linear infinite;
  -webkit-animation: spin 1.4s linear infinite;
  background: transparent;
  stroke: ${(props) => (props.color && props.theme[props.color]) || props.theme.blue};
  stroke-dasharray: 80px, 200px;
  stroke-dashoffset: 0px;

  @keyframes spin {
    0% {
      stroke-dasharray: 1px, 200px;
      stroke-dashoffset: 0px;
    }
    50% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -15px;
    }
    100% {
      stroke-dasharray: 100px, 200px;
      stroke-dashoffset: -125px;
    }
  } ;
`;
exports.Spinner = (props) => {
    return (React.createElement(SpinnerContainer, { size: props.size || '50' },
        React.createElement(SpinnerRotator, { size: props.size || '50' },
            React.createElement("svg", { height: props.size || '50', width: props.size || '50', viewBox: `22 22 44 44` },
                React.createElement(Progress, { cx: 44, cy: 44, r: 20.2, strokeWidth: 3.6, fill: "none", color: props.color || 'blue' })))));
};
//# sourceMappingURL=Spinner.js.map